<template>
  <div class="content">
    <div class="img_bj">
      <img src="../../assets/images/index/gonglueditu.png" />
      <div class="Decoration">
        <div class="head_title">
          <div class="title1">装修攻略</div>
          <div class="title2">了解桔家云整装产品，获取装修攻略</div>
          <div class="Scribing"></div>
        </div>
        <div class="Decoration-main">
          <div class="Decoration-left" @click="todeco1(deco1[0].id)">
            <div class="left-Bigpicture">
              <img src="../../assets/images/index/deco1.jpg" oncontextmenu="return false;" />
            </div>
            <div class="left-text">
              <div>
                <div class="Decoration-main-title">新中式装修风格的特点与装修元素</div>
                <div
                  class="Decoration-text"
                >不同的装修风格打造出不一样的家居环境,业主对此也有不同的选择。现在常见的家装风格有中式风格、新中式风格、现简约风格、地中海风格等等。下面，具体介绍新中式装修风格的特点，并说说新中装修元素有哪些,感兴趣的朋友赶紧点进来看看吧~</div>
              </div>
            </div>
          </div>
          <div class="Decoration-right">
            <div
              class="Decoration-right-main"
              @click="todeco(item)"
              v-for="(item,index) in deco"
              :key="index"
            >
              <div class="right-main-img">
                <img v-lazy="item.imgurl" src alt oncontextmenu="return false;" />
              </div>
              <div class="right-main-text">
                <div class="text-main">
                  <div class="right-main-title">{{item.title}}</div>
                  <div class="Decoration-text">{{item.detail}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  data() {
    return {
      deco: [
        {
          imgurl: require("../../assets/images/index/deco2.jpg"),
          id: "15",
          title: "装修材料有哪些？",
          detail:
            "装修都有哪些内容呢？这里有最详细的清单攻略，了解装修清单让我们对装修心中有数。",
        },
        {
          imgurl: require("../../assets/images/index/deco3.jpg"),
          id: "42",
          title: "如何设计装修才最环保呢？",
          detail:
            "随着人们的环保意识的提升， 装修房子不仅也美观也要讲究环保，那么家庭装修怎样才最环保呢？",
        },
        {
          imgurl: require("../../assets/images/index/deco4.png"),
          id: "18",
          title: "浅色地板搭配窗帘",
          detail:
            "地板与窗帘的搭配影响到家居美观度，不同颜色的地板需要搭配合适颜色的窗帘，确保完美的装饰效果。",
        },
      ],
      deco1: [
        {
          id: "8",
        },
      ],
    };
  },
  methods: {
    todeco1(itemid) {
      this.$router.push({ path: "/HowDeco", query: { resl: itemid } });
    },
  },
};
</script>
<style scoped>
.content {
  width: 100%;
  padding-top: 57px;
  overflow: hidden;
  background-color: #f4f4f4;
}
.img_bj {
  width: 100%;
  position: relative;
}
.img_bj img{
  height: 767px;
}
.Decoration {
  width: 1280px;
  position: absolute;
  z-index: 10;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.Decoration-main {
  width: 100%;
  height: 100%;
  display: flex;
  margin-top: 50px;
}
.Decoration-left {
  width: 760px;
  height: 530px;
  cursor: pointer;
  background: #fff;
}
.left-Bigpicture {
  width: 760px;
  height: 323px;
}
.left-Bigpicture img {
  width: 100%;
  height: 100%;
}
.left-text {
  width: 90%;
  height: 150px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.Decoration-main-title {
  font-size: 16px;
  border-bottom: 1px solid #525252;
  text-align: left;
  color: #000;
}
.Decoration-text {
  color: #999999;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  font-size: 14px;
}
.Decoration-right {
  width: 510px;
  margin-top: -10px;
}
.Decoration-right-main {
  width: 510px;
  height: 170px;
  margin-left: 10px;
  margin-top: 10px;
  display: flex;
}
.right-main-img {
  width: 200px;
}
.right-main-img img {
  width: 100%;
  height: 100%;
}
.right-main-text {
  width: 310px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.text-main {
  width: 90%;
  height: 100px;
}
.right-main-title {
  border-bottom: 1px solid #525252;
  text-align: left;
  color: #000;
  font-size: 16px;
  font-weight: 500;
}
.title1 {
  width: 100%;
  text-align: center;
  font-size: 30px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 3px;
  color: #333333;
}
.title2 {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 2px;
  color: #666666;
}
.Scribing {
  width: 50px;
  height: 6px;
  background-color: #bc001d;
  margin: 0 auto;
  margin-top: 20px;
}
.tishi {
  width: 1260px;
  height: 50px;
  line-height: 50px;
  text-align: right;
  margin: 0 auto;
  font-size: 12px;
}
</style>
